import { render, staticRenderFns } from "./add-bank-card.vue?vue&type=template&id=0b9d0c06&scoped=true&"
import script from "./add-bank-card.vue?vue&type=script&lang=js&"
export * from "./add-bank-card.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-card.vue?vue&type=style&index=0&id=0b9d0c06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d0c06",
  null
  
)

export default component.exports